/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_FocusInputs */

const en_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I’ll focus`)
};

const ar_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سوف اركز`)
};

const de_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich werde mich darauf konzentrieren`)
};

const es_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me voy a concentrar`)
};

const fr_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je vais me concentrer`)
};

const it_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi concentrerò`)
};

const ja_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中する`)
};

const ko_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중할게요`)
};

const pt_br_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manter o foco`)
};

const ru_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я буду фокусироваться`)
};

const th_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฉันจะโฟกัส`)
};

const tr_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanacağım`)
};

const zh_cn_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我会专心`)
};

const zh_tw_btn_focus = /** @type {(inputs: Btn_FocusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我會專心`)
};

/**
* | output |
* | --- |
* | "I’ll focus" |
*
* @param {Btn_FocusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_focus = /** @type {((inputs?: Btn_FocusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_FocusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_focus(inputs)
	if (locale === "ar") return ar_btn_focus(inputs)
	if (locale === "de") return de_btn_focus(inputs)
	if (locale === "es") return es_btn_focus(inputs)
	if (locale === "fr") return fr_btn_focus(inputs)
	if (locale === "it") return it_btn_focus(inputs)
	if (locale === "ja") return ja_btn_focus(inputs)
	if (locale === "ko") return ko_btn_focus(inputs)
	if (locale === "pt_br") return pt_br_btn_focus(inputs)
	if (locale === "ru") return ru_btn_focus(inputs)
	if (locale === "th") return th_btn_focus(inputs)
	if (locale === "tr") return tr_btn_focus(inputs)
	if (locale === "zh_cn") return zh_cn_btn_focus(inputs)
	return zh_tw_btn_focus(inputs)
});